
import { motion } from 'framer-motion';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* New background image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/1ac0532657c3a1ec84395845b299c7db.jpeg)'
        }}
      />
      
      {/* Hero content */}
      <div className="relative z-30 max-w-6xl mx-auto px-4 md:px-6 text-center">
        <div className="backdrop-blur-md bg-white/10 p-6 md:p-12 lg:p-16 rounded-2xl md:rounded-3xl border border-white/20 shadow-2xl mx-4 md:mx-0">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-3xl md:text-5xl lg:text-7xl font-bold mb-4 md:mb-6 text-white leading-tight"
          >
            Strategic Investments in
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-cyan-300">
              Emerging Technologies
            </span>
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-base md:text-lg lg:text-xl text-blue-100 max-w-2xl lg:max-w-3xl mx-auto leading-relaxed"
          >
            A private holding company advancing long-term value through disciplined investment, strategic advisory, and the facilitation of major technology acquisitions.
          </motion.p>
        </div>
      </div>

      {/* Gradient overlay for better text readability */}
      <div className="absolute inset-0 z-25 bg-gradient-to-b from-black/20 via-transparent to-black/30" />
    </section>
  );
}